import { defineComponent as m, openBlock as t, createElementBlock as o, mergeProps as p, unref as e, renderSlot as Z, createElementVNode as n, createCommentVNode as i } from "vue";
import { useScalarIcon as u } from "../hooks/useScalarIcon.js";
const L = { key: 0 }, g = { key: 1 }, M = { key: 2 }, f = { key: 3 }, k = { key: 4 }, y = { key: 5 }, h = {
  name: "ScalarIconEmpty"
}, b = /* @__PURE__ */ m({
  ...h,
  props: {
    label: {},
    weight: {}
  },
  setup(a) {
    const r = a, { bind: s, weight: A } = u(r);
    return (d, l) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, e(s)), [
      Z(d.$slots, "default"),
      e(A) === "bold" ? (t(), o("g", L, l[0] || (l[0] = [
        n("path", { d: "M203.63,62.65l13.25-14.58a12,12,0,0,0-17.76-16.14L185.88,46.49A100,100,0,0,0,52.37,193.35L39.12,207.93a12,12,0,1,0,17.76,16.14l13.24-14.56A100,100,0,0,0,203.63,62.65ZM52,128A75.94,75.94,0,0,1,169.58,64.43l-100.91,111A75.6,75.6,0,0,1,52,128Zm76,76a75.52,75.52,0,0,1-41.58-12.43l100.91-111A75.94,75.94,0,0,1,128,204Z" }, null, -1)
      ]))) : e(A) === "duotone" ? (t(), o("g", g, l[1] || (l[1] = [
        n("path", {
          d: "M216,128a88,88,0,1,1-88-88A88,88,0,0,1,216,128Z",
          opacity: "0.2"
        }, null, -1),
        n("path", { d: "M198.24,62.63l15.68-17.25a8,8,0,0,0-11.84-10.76L186.4,51.86A95.95,95.95,0,0,0,57.76,193.37L42.08,210.62a8,8,0,1,0,11.84,10.76L69.6,204.14A95.95,95.95,0,0,0,198.24,62.63ZM48,128A80,80,0,0,1,175.6,63.75l-107,117.73A79.63,79.63,0,0,1,48,128Zm80,80a79.55,79.55,0,0,1-47.6-15.75l107-117.73A79.95,79.95,0,0,1,128,208Z" }, null, -1)
      ]))) : e(A) === "fill" ? (t(), o("g", M, l[2] || (l[2] = [
        n("path", { d: "M170.49,91.59A56,56,0,0,1,97.54,175ZM128,72a56,56,0,0,0-42.49,92.41l73-83.37A55.67,55.67,0,0,0,128,72Zm104,56A104,104,0,1,1,128,24,104.13,104.13,0,0,1,232,128Zm-32,0a71.68,71.68,0,0,0-18.89-48.55L186,73.27a8,8,0,1,0-12-10.54l-4.91,6.18A72,72,0,0,0,74.89,176.55L70,182.73a8,8,0,0,0,12,10.54l4.91-6.18A71.95,71.95,0,0,0,200,128Z" }, null, -1)
      ]))) : e(A) === "light" ? (t(), o("g", f, l[3] || (l[3] = [
        n("path", { d: "M195.51,62.66,212.44,44A6,6,0,1,0,203.56,36L186.63,54.58A94,94,0,0,0,60.49,193.34L43.56,212A6,6,0,0,0,52.44,220l16.93-18.62A94,94,0,0,0,195.51,62.66ZM46,128A81.93,81.93,0,0,1,178.53,63.49L68.59,184.43A81.69,81.69,0,0,1,46,128Zm82,82a81.57,81.57,0,0,1-50.53-17.49L187.41,71.57A81.94,81.94,0,0,1,128,210Z" }, null, -1)
      ]))) : e(A) === "regular" ? (t(), o("g", k, l[4] || (l[4] = [
        n("path", { d: "M198.24,62.63l15.68-17.25a8,8,0,0,0-11.84-10.76L186.4,51.86A95.95,95.95,0,0,0,57.76,193.37L42.08,210.62a8,8,0,1,0,11.84,10.76L69.6,204.14A95.95,95.95,0,0,0,198.24,62.63ZM48,128A80,80,0,0,1,175.6,63.75l-107,117.73A79.63,79.63,0,0,1,48,128Zm80,80a79.55,79.55,0,0,1-47.6-15.75l107-117.73A79.95,79.95,0,0,1,128,208Z" }, null, -1)
      ]))) : e(A) === "thin" ? (t(), o("g", y, l[5] || (l[5] = [
        n("path", { d: "M192.76,62.72l18.2-20A4,4,0,0,0,205,37.31l-18.2,20a92,92,0,0,0-123.6,136l-18.2,20A4,4,0,1,0,51,218.69l18.2-20A92,92,0,0,0,192.76,62.72ZM44,128A84,84,0,0,1,181.46,63.25L68.63,187.36A83.72,83.72,0,0,1,44,128Zm84,84a83.64,83.64,0,0,1-53.46-19.25L187.37,68.64A84,84,0,0,1,128,212Z" }, null, -1)
      ]))) : i("", !0)
    ], 16));
  }
});
export {
  b as default
};
